import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../store";
const configJSON = require("../../config/countryConfig/countryRights_v1.json");
const allCountryConfig = configJSON.config;
import Utility from "../../utility/Utility";
const languageCookie = Utility.getCookie("KEYCLOAK_LOCALE");

const initialState = {
  countryLanguages: ["en"],
  countryLanguageOptions: [{ label: "English", id: "en" }],
  countryIdentifierOptions: [""],
  availableRoles: [""],
  userCountry: "in",
  defaultLanguage:"en"
};

const getStateConfig = (stateName: string, states: []): any => {
  return states.find(
    (state: any) => state?.label?.toLowerCase() == stateName?.toLowerCase()
  );
};

const languageMapping = (userCountry:string) => {
  const mapping = allCountryConfig[userCountry]?.language_mapping;
  const languages = allCountryConfig[userCountry]?.available_languages;
  const options =
      languages &&
      languages.map((lang: any) => {
        return { label: mapping[lang], id: lang };
      });
  return options;
};

export const UserConfigSlice = createSlice({
  name: "userConfigDetails",
  initialState,
  reducers: {
    applyCountryLevelConfig: (state, action: PayloadAction<string>) => {
      state.userCountry = action.payload;
      const countryConfig = allCountryConfig[action.payload];
      state.availableRoles = countryConfig?.available_roles;
      state.countryLanguages = countryConfig?.available_languages;
      state.countryLanguageOptions = languageMapping(action.payload);
      state.countryIdentifierOptions = countryConfig?.available_identifiers;
      state.defaultLanguage = countryConfig?.default_language;
    },
    /**override country configuration */
    applyStateLevelConfig: (state, action: PayloadAction<string>) => {
      const statesInCountry = allCountryConfig[state.userCountry]?.states;
      const stateConfig = getStateConfig(action.payload, statesInCountry);
      if(stateConfig) {
        if (stateConfig?.available_roles) {
          state.availableRoles = stateConfig?.available_roles;
        }
        if (stateConfig?.available_languages) {
          state.countryLanguages = stateConfig?.available_languages;
        }
        if (stateConfig?.default_language && languageCookie == undefined) {
          state.defaultLanguage = stateConfig?.default_language;
        }
      }
    }
  }
});

export const {
  applyCountryLevelConfig,
  applyStateLevelConfig
} = UserConfigSlice.actions;
export const UserConfigState = (state: RootState) => state.userConfigDetails;
export default UserConfigSlice.reducer;
